import { CommonModule } from '@angular/common';
import { ApplicationRef, ComponentFactoryResolver, DOCUMENT, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { ConfigModule } from 'NewAngular/config/config.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { SecurityHeaderControlModule } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.module';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { StressTestComponent } from 'StressTestsApp/ts/apps/stress-test-app/components/stress-test/stress-test.component';
import { getLogger } from 'NewAngular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class MutualFundsStressTestAppModule {
    constructor(_document, componentFactoryResolver) {
        this._document = _document;
        this.componentFactoryResolver = componentFactoryResolver;
    }
    ngDoBootstrap(applicationRef) {
        MutualFundsStressTestAppModule.bootstrapComponents.forEach((component) => {
            const { selector } = this.componentFactoryResolver.resolveComponentFactory(component);
            const elements = this._document.querySelectorAll(selector);
            elements.forEach((element) => {
                applicationRef.bootstrap(component, element);
            });
        });
    }
}
MutualFundsStressTestAppModule.bootstrapComponents = [
    TopBarNavComponent,
    StressTestComponent,
    SecurityHeaderControlComponent,
    SideMenuComponent,
];
MutualFundsStressTestAppModule.ɵfac = function MutualFundsStressTestAppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsStressTestAppModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
MutualFundsStressTestAppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsStressTestAppModule });
MutualFundsStressTestAppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        FormsModule,
        ConfigModule,
        CommonModule,
        NavigationModule,
        SecurityHeaderControlModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
